import styled from "styled-components";
//components
import Text from "components/Text"
import { Button } from "components/Button";
import { Row } from "components/Layout/Grid";

export const InputTitle = styled(Text)`
    margin: 40px 0 4px;
`;

export const SearchContainer = styled(Row)`
  display: flex;
  align-items: center;
  
  .searchInput {
    width: 545px;
    display: flex;
    flex-direction: column;
    position: relative;

    &.clearSearch {
      img {
        margin-right: 2px;
        cursor: pointer;
      }
    }
  }
  
  span{
    cursor: pointer;
    font-size: 12px;
    color: #364863;
    text-decoration: underline;
    margin-left: 20px;

    &.blocked-clear {
      cursor: not-allowed;
    }
  }

  @media screen and (max-width: 1190px) {
    flex-direction: column;
    align-items: flex-start;

    .tags-search {
      margin-top: 30px;
    }
  }
  
  @media screen and (max-width: 900px) {
    .tags-search {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      
      > span {
        min-width: 100px;
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  @media screen and (max-width: 660px) {
    .container-search {
      width: 100%;
      
      > button {
        width: 90px;
      }
    }

    .searchInput {
      width: calc(100% - 90px);
    }
  }

  @media screen and (max-width: 420px) {
    flex-direction: column;

    .tags-search {
      width: 100%;
      display: block;

      > span {
        text-align: center;
      }
    }
  }
`;

export const MessageError = styled(Text)`
  position: absolute;
  bottom: -15px;
`

export const FilterButton = styled(Button).attrs({  
  className: "button bg-greenDarkViveo ml-2 px-4"
})``